<script setup lang="ts">
const props = defineProps({
  title: { type: String, default: '' }
})

const router = useRouter()

const clickBack = () => {
  //   if (props.title) navigateTo('/dashboard')
  //   else router.back()
  router.back()
}

const { status, data: user } = useAuth()

const show = computed(() => {
  return status.value === 'authenticated' && isStudent(user.value)
})
</script>

<template>
  <div v-if="show" class="mobile-back-btn">
    <div class="container">
      <div class="arrow-btn-wrapper clickable" @click="clickBack">
        <CommonIconArrow />
      </div>

      <div class="title">{{ props.title }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-back-btn {
  position: fixed;
  top: 0;
  left: 0;
  height: calc(vaR(--navbarHeight) - 2px);
  min-width: 50%;
  background-color: white;
  z-index: 100;

  .container {
    display: flex;
    align-items: center;
    padding-top: 2px;
    position: relative;
    gap: 15px;
  }

  .arrow-btn-wrapper {
    position: relative;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background: var(--bgMedium);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      transform: scaleX(-1);
      fill: var(--textM2);
    }
  }

  .title {
    font-size: 1.05rem;
    color: var(--textM2);
    font-weight: 500;
  }
}

@media (min-width: 600px) {
  .mobile-back-btn {
    display: none;
  }
}
</style>
